export default {
  title: 'Digital ordering',
  subtitle: 'Understand how customers order digitally across your locations.',
  loading: 'Loading Digital ordering',
  tabs: {
    orders_by_client: {
      title: 'Orders by client',
      page_title: 'Orders by client - Digital ordering | Thanx',
    },
    orders_by_handoff_mode: {
      title: 'Orders by handoff mode',
      page_title: 'Orders by handoff mode - Digital ordering | Thanx',
    },
    average_orders_per_location_per_month: {
      title: 'Average orders per location per month',
      page_title:
        'Average orders per location per month - Digital ordering | Thanx',
    },
    channel_preference: {
      title: 'Channel preference',
      page_title: 'Channel preference - Digital ordering | Thanx',
    },
    digital_orders_by_hour: {
      title: 'Digital orders by hour',
      page_title: 'Digital orders by hour - Digital ordering | Thanx',
    },
    item_popularity_in_digital_orders: {
      title: 'Item popularity in digital orders',
      page_title:
        'Item popularity in digital orders - Digital ordering | Thanx',
    },
  },
}
